import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { scraper } from 'actionCreators';
import { isEmpty } from '../../../../../utils';
import ColoredButton from 'components/ColoredButton';
import PageActionBar from 'components/PageActionBar';
import Loading from 'components/Loading';
import S from './scraper.scss';
import contentAreaStyles from 'styles/contentArea';

class Scraper extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const fileInput = this.fileInput.files;
    if (fileInput.length === 0) {
      this.errorMessage = 'Please select a file.';
    }
    Array.from({ length: fileInput.length }).forEach((_, i) => formData.append(`scraper[asset-${i}]`, fileInput[i]));
    this.props.scraper(formData);
  }

  phaseLink = phase => (phase.assessment ? phase.assessment.id : phase.installation.id);

  render() {
    const { documents, loading } = this.props;

    let allPages;
    if (!isEmpty(documents)) {
      allPages = documents.map(doc =>
        (
          <div key={doc.id} className={S.documents}>
            <div className={doc.failure === true ? S.fail : S.success}>
              {doc.original_name &&
                <p className={S.document}>Document Name: {doc.original_name}</p>
              }
              {doc.errors &&
                <p className={S.document}>Errors: {doc.errors}</p>
              }
            </div>
            {doc.pages &&
              doc.pages.map(page => (
                <div key={page.id} className={S.page}>{(page.errors.length > 0 || page.subtype) &&
                  <div>
                    {page.original_name &&
                      <p>Page: {page.id + 1}</p>
                    }
                    {page.phase && (page.phase.assessment || page.phase.installation) &&
                      <p><Link to={`/phases/${this.phaseLink(page.phase)}/info`} target="_blank">View Phase</Link></p>
                    }
                    {page.errors.length > 0 &&
                      <p>Errors: {page.errors}</p>
                    }
                    {page.type &&
                      <p>Type: {page.type}</p>
                    }
                    {page.subtype &&
                      <p>Subtype: {page.subtype}</p>
                    }
                  </div>
                }</div>
              ),
            )
          }
          </div>
        ),
      );
    }
    return (
      <div>
        <PageActionBar
          showAdd={false}
          showFiltersBtn={false}
          title="Scraper"
        />
        <div className={contentAreaStyles.contentAreaContainer}>
          <div className={contentAreaStyles.contentArea}>
            <form onSubmit={this.handleSubmit} >
              <input type="file" placeholder="Select a file" ref={(c) => { this.fileInput = c; }} multiple />
              <ColoredButton type="submit" disabled={loading}>Scrape</ColoredButton>
            </form>
            {!isEmpty(documents) &&
              <div>
                {allPages}
              </div>
            }
            {loading &&
              <Loading />
            }
          </div>
        </div>
      </div>
    );
  }
}

Scraper.propTypes = {
  scraper: PropTypes.func,
  documents: PropTypes.array,
  loading: PropTypes.bool,
};

const mapStateToProps = state =>
   ({
     documents: state.scraper.documents,
     loading: state.scraper.loading,
   })
;

export default connect(mapStateToProps, {
  scraper,
})(Scraper);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/tools/scraper/index.jsx